export default "__VITE_ASSET__2X5AKDh0__"